import React from "react";
import { useEffect } from "react";
import { useState } from "react";

export const useAudio = (audioSrc) => {
  const [audio] = useState(new Audio(audioSrc));
  const [playing, setPlaying] = useState(false);

  const toggle = () => setPlaying(!playing);

  const play = async () => {
    try {
      audio.currentTime = 0;
      await audio.play();
      setPlaying(true);
    } catch (error) {
      console.error("Error playing audio:", error);
    }
  };

  const pause = () => {
    audio.pause();
    setPlaying(false);
  };

  useEffect(() => {
    playing ? audio.play() : audio.pause();
  }, [playing, audio]);

  useEffect(() => {
    audio.addEventListener("ended", () => setPlaying(false));
    return () => {
      audio.removeEventListener("ended", () => setPlaying(false));
    };
  }, [audio]);

  return { playing, toggle, play, pause };
};
